/**
 * App entry: providers, router root, and toaster above the auth spinner.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import { BrandingProvider } from './providers/BrandingProvider';
import { AuthProvider } from './providers/AuthProvider';
import { Toaster } from './components/ui/toast';
import { useAuthStore } from './stores/authStore';
import './index.css';

/**
 * App bootstrap. RootToaster sits above AuthProvider so toasts show during the spinner.
 * `hasNavbar` follows the auth store so the offset is correct once the app is loaded.
 */
function RootToaster() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return <Toaster hasNavbar={isAuthenticated} />;
}

/** Render the app. 
 * Strict mode is enabled to detect potential issues with the app.
 * BrandingProvider provides the branding configuration.
 * AuthProvider provides the authentication context.
 * App is the main component of the app.
 * RootToaster is the toaster component that shows the toasts.
*/
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrandingProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
      <RootToaster />
    </BrandingProvider>
  </React.StrictMode>,
);
